import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Label,
} from "recharts";
import * as GraphAPI from "../api/graph-api";
import { format } from "date-fns";
import frLocale from "date-fns/locale/fr";
import { WithTranslationLangProps } from "../utils/i18next/with-translation-keys";
import { withTranslation } from "react-i18next";
import { capitalize } from "../utils/capitalize";

interface IGraphOrigDestPerDayProps extends WithTranslationLangProps {
  dataKeysDef?: { key: string; label: string }[];
  perDayData?: GraphAPI.GraphODPerDayData[];
}

class GraphOrigDestPerDay extends React.Component<IGraphOrigDestPerDayProps> {
  private getAxisValueLabel(dataObj: GraphAPI.GraphODPerDayData): string {
    return capitalize(format(dataObj.day, "iiii", { locale: frLocale }));
  }

  render() {
    if (this.props.perDayData && this.props.dataKeysDef)
      return (
        <>
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={this.props.perDayData}>
              <CartesianGrid strokeDasharray="3 3" vertical={false} />
              <XAxis dataKey={this.getAxisValueLabel} />
              <YAxis
                width={50}
                domain={[
                  (dataMin: any) => Math.max(0, Math.floor(dataMin) - 3),
                  100,
                ]}
              >
                <Label
                  angle={-90}
                  value={this.props.t("chart_legend_reliability")}
                  position="insideLeft"
                  style={{ textAnchor: "middle" }}
                />
              </YAxis>
              <Tooltip
                formatter={(value, _name, _props) =>
                  Number(value).toFixed(2) + "%"
                }
              />
              <Legend wrapperStyle={{ position: "relative", bottom: "35px" }} />
              <Line
                type="monotone"
                dataKey={this.props.dataKeysDef[0].key}
                name={this.props.dataKeysDef[0].label}
                stroke="#24356d"
                strokeWidth={2}
              />
              <Line
                type="monotone"
                dataKey={this.props.dataKeysDef[1].key}
                name={this.props.dataKeysDef[1].label}
                stroke="#9cc5c4"
                strokeWidth={2}
                strokeDasharray="5 2"
                dot={false}
              />
            </LineChart>
          </ResponsiveContainer>
        </>
      );
  }
}

export default withTranslation()(GraphOrigDestPerDay);
